import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d319d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-form__item" }
const _hoisted_2 = { class: "details-form__item" }
const _hoisted_3 = { class: "details-form__item__title" }
const _hoisted_4 = { class: "profile-creation-wizard__content-indexable-row" }
const _hoisted_5 = { class: "form indexable-form" }
const _hoisted_6 = { class: "profile-creation-wizard__content-indexable-description" }
const _hoisted_7 = {
  class: "m-link",
  href: "#"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-creation-wizard__side" }, null, -1))

import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import SeniorityLevelSelection from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/SeniorityLevelSelection.vue';
    import {useTranslation, useGlobalProperties} from '@malt/vue3-use';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {computed, inject, onBeforeMount, ref} from 'vue';
    import actions from '@/profile-creation-wizard/store/completion/actions';
    import {useStore} from 'vuex';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyStep',
  setup(__props) {

    const store = useStore();
    const {msg} = useTranslation();
    const context = useGlobalProperties();

    const trackingRepository = inject(DI.trackingRepository);

    const seniorityLevelSelection = ref<SeniorityLevelSelection>(null);
    const indexable = ref(true);
    const showMoreEnabled = ref(false);
    const isLoadingButtonFinish = ref(false);
    const hasValidFieldPart = computed(() => seniorityLevelSelection.value != null);

    function selectSeniorityLevel(seniorityLevel: string | null): void {
        seniorityLevelSelection.value = seniorityLevel ? SeniorityLevel[seniorityLevel] : null;
    }

    function handleChangeIndexable(changeIndexableEvent: CustomEvent) {
        indexable.value = changeIndexableEvent.detail;
    }

    async function goNext(): Promise<void> {
        isLoadingButtonFinish.value = true;
        if (seniorityLevelSelection.value) {
            await saveSeniorityLevelSelection(seniorityLevelSelection.value);
        }

        if (!indexable.value) {
            await store.dispatch(actions.updateProfilePreference, false);
        }

        await trackingRepository!.track('completion-ended-freelancer');

        location.href = `/profile`;
    }

    async function saveSeniorityLevelSelection(seniorityLevelSelection: SeniorityLevel): Promise<void> {
        await store.dispatch(actions.updateSeniority, seniorityLevelSelection);
    }

    function toggleShowMoreIndexable(): void {
        showMoreEnabled.value = !showMoreEnabled.value;
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!

  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": hasValidFieldPart.value,
    "show-skip-step": true,
    "is-loading": isLoadingButtonFinish.value,
    "is-skip-enabled": !hasValidFieldPart.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SeniorityLevelSelection, {
          class: "seniority-level-selection",
          "seniority-level": seniorityLevelSelection.value,
          "bottom-sheet-selector-prop": "#seniority-level-bottom-sheet",
          "data-heap-tooltip-id-prop": "profile-creation-tooltip-seniority-level",
          onSeniorityLevelSelected: selectSeniorityLevel
        }, null, 8, ["seniority-level"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.indexable.title')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_joy_checkbox, {
              checked: indexable.value,
              name: "indexable",
              value: indexable.value,
              onValueChange: handleChangeIndexable
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.indexable.checkbox')), 1)
              ]),
              _: 1
            }, 8, ["checked", "value"])
          ]),
          _createVNode(_component_joy_highlight, {
            level: "info",
            "display-icon": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.indexable.subtitle.short')) + " ", 1),
                _createElementVNode("span", { onClick: toggleShowMoreIndexable }, [
                  _createElementVNode("a", _hoisted_7, _toDisplayString(showMoreEnabled.value ? _unref(msg)('generic.show.less') : _unref(msg)('generic.show.more')), 1)
                ]),
                (showMoreEnabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.indexable.subtitle.details')), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    "step-side": _withCtx(() => [
      _hoisted_9
    ]),
    _: 1
  }, 8, ["is-step-valid", "is-loading", "is-skip-enabled"]))
}
}

})